import { useState, useEffect, useMemo } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const API = process.env.REACT_APP_BACKEND_URL;

const PREVIEW_PAGES = {
  carte: [
    { title: 'APERO & TAPAS', sections: ['Tapas'], hideHeaders: true, title2: 'NOS ENTREES', sections2: ['Entrees'], hideHeaders2: true, footer: 'Menu Enfant - 16\u20ac  |  Boisson  |  Tenders  |  Deux boules de glace' },
    { title: 'NOS PLATS', sections: ['Viandes'], hideHeaders: true, subsection: 'Poissons', sections2: ['Poissons'], hideHeaders2: true, footer: 'Garnitures 3\u20ac  \u00b7  Sauces 3\u20ac\nFrites \u00b7 Riz \u00b7 Legumes \u00b7 Gratin  |  Aioli Maison \u00b7 Roquefort' },
  ],
  vins: [
    { title: 'Carte des Vins', subtitle: true, sections: ['Vins Blancs', 'Vins Roses', 'Vins Rouges'] },
  ],
  boissons: [
    { title: 'Boissons & Spiritueux', subtitle: true, sections: ['Champagne', 'Aperitifs', 'Bieres'] },
    { title: 'Spiritueux & Softs', subtitle: true, sections: ['Spiritueux', 'Softs', 'Cafes'] },
  ],
  desserts: [
    { title: 'Nos Desserts', subtitle: true, sections: ['Desserts'], hideHeaders: true },
  ],
};

function PrintPage({ pageConfig, items, pageNum, totalPages, showRoueQR, isLastPage, roueUrl }) {
  const renderSection = (sectionName, sectionItems, hideHeader = false) => {
    const active = sectionItems.filter(i => i.disponible !== false);
    if (active.length === 0) return null;
    return (
      <div key={sectionName} style={{ marginBottom: '20px' }}>
        {!hideHeader && (
          <>
            <h3 style={{ textAlign: 'center', fontWeight: 'bold', letterSpacing: '0.25em', textTransform: 'uppercase', marginBottom: '6px', color: '#1B2A52', fontFamily: 'Arial, sans-serif', fontSize: '11px' }}>
              {sectionName.toUpperCase()}
            </h3>
            <div style={{ width: '100%', height: '1px', background: '#1B2A52', marginBottom: '14px' }} />
          </>
        )}
        {active.map(item => (
          <div key={item.id} style={{ marginBottom: '10px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: '16px' }}>
              <span style={{ fontWeight: 'bold', fontFamily: 'Georgia, serif', color: '#1B2A52', fontSize: '13px' }}>{item.nom}</span>
              <span style={{ fontWeight: 'bold', fontFamily: 'Georgia, serif', color: '#1B2A52', fontSize: '13px', flexShrink: 0 }}>{item.prix_ttc} &euro;</span>
            </div>
            {item.description && (
              <p style={{ fontStyle: 'italic', marginTop: '2px', fontFamily: 'Georgia, serif', color: '#888', fontSize: '10px' }}>{item.description}</p>
            )}
          </div>
        ))}
      </div>
    );
  };

  const grouped = {};
  items.forEach(item => {
    const sec = item.section || 'Autre';
    if (!grouped[sec]) grouped[sec] = [];
    grouped[sec].push(item);
  });

  return (
    <div className="print-menu-page" style={{ background: '#fff', color: '#1B2A52', fontFamily: 'Georgia, serif', maxWidth: '480px', margin: '0 auto', padding: '36px 40px 20px', pageBreakAfter: 'always', minHeight: '680px', position: 'relative', display: 'flex', flexDirection: 'column' }}>
      {/* Logo */}
      <div style={{ textAlign: 'center', marginBottom: '10px' }}>
        <img src="/logo-carte.jpg" alt="Le Mas" style={{ height: '90px', objectFit: 'contain', margin: '0 auto', display: 'block' }} />
      </div>
      <div style={{ width: '100%', height: '1px', background: '#1B2A52' }} />
      <p style={{ textAlign: 'center', fontStyle: 'italic', padding: '6px 0', color: '#888', fontSize: '9px', fontFamily: 'Georgia, serif' }}>Saint-Laurent-de-la-Salanque &middot; Pays Catalan</p>
      <div style={{ width: '100%', height: '1px', background: '#1B2A52', marginBottom: '18px' }} />

      {/* Title */}
      {pageConfig.title && (
        <>
          <div style={{ width: '100%', height: '1px', background: '#1B2A52', marginBottom: '4px' }} />
          <h2 style={{ textAlign: 'center', fontWeight: 'bold', letterSpacing: '0.4em', textTransform: 'uppercase', padding: '6px 0', color: '#1B2A52', fontFamily: 'Arial, sans-serif', fontSize: pageConfig.subtitle ? '12px' : '14px' }}>
            {pageConfig.title}
          </h2>
          <div style={{ width: '100%', height: '1px', background: '#1B2A52', marginBottom: '18px' }} />
        </>
      )}

      {/* Sections */}
      {pageConfig.sections?.map(sec => renderSection(sec, grouped[sec] || [], pageConfig.hideHeaders))}

      {/* Title 2 */}
      {pageConfig.title2 && (
        <>
          <div style={{ width: '100%', height: '1px', background: '#1B2A52', margin: '14px 0 4px' }} />
          <h2 style={{ textAlign: 'center', fontWeight: 'bold', letterSpacing: '0.4em', textTransform: 'uppercase', padding: '6px 0', color: '#1B2A52', fontFamily: 'Arial, sans-serif', fontSize: '14px' }}>
            {pageConfig.title2}
          </h2>
          <div style={{ width: '100%', height: '1px', background: '#1B2A52', marginBottom: '18px' }} />
        </>
      )}
      {pageConfig.sections2?.map(sec => {
        if (pageConfig.subsection && sec === pageConfig.sections2[0]) {
          return (
            <div key={sec}>
              <p style={{ textAlign: 'center', fontStyle: 'italic', margin: '14px 0', fontFamily: 'Georgia, serif', color: '#1B2A52', fontSize: '12px' }}>&mdash; {pageConfig.subsection} &mdash;</p>
              {renderSection(sec, grouped[sec] || [], pageConfig.hideHeaders2)}
            </div>
          );
        }
        return renderSection(sec, grouped[sec] || [], pageConfig.hideHeaders2);
      })}

      {/* Footer text */}
      {pageConfig.footer && (
        <>
          <p style={{ textAlign: 'center', color: '#1B2A52', letterSpacing: '0.15em', fontSize: '10px', margin: '16px 0' }}>&mdash; &#9830; &mdash;</p>
          <p style={{ textAlign: 'center', fontStyle: 'italic', whiteSpace: 'pre-line', fontFamily: 'Georgia, serif', color: '#1B2A52', fontSize: '10px' }}>{pageConfig.footer}</p>
        </>
      )}

      {/* Roue QR */}
      {showRoueQR && isLastPage && (
        <div style={{ marginTop: '24px', paddingTop: '12px', borderTop: '1px solid #1B2A52', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px' }}>
          <QRCodeSVG value={roueUrl || 'https://lemas.fr/roue'} size={55} bgColor="#FFFFFF" fgColor="#1B2A52" level="L" />
          <div>
            <p style={{ fontWeight: 'bold', letterSpacing: '0.1em', textTransform: 'uppercase', color: '#1B2A52', fontFamily: 'Arial, sans-serif', fontSize: '9px' }}>Tentez votre chance !</p>
            <p style={{ fontStyle: 'italic', marginTop: '3px', color: '#666', fontFamily: 'Georgia, serif', fontSize: '8px' }}>Scannez le QR code et tournez<br />la roue pour gagner un cadeau</p>
          </div>
        </div>
      )}

      {/* Bottom footer */}
      <div style={{ marginTop: 'auto', paddingTop: '16px' }}>
        <div style={{ width: '100%', height: '1px', background: '#1B2A52', marginBottom: '8px' }} />
        <p style={{ textAlign: 'center', fontFamily: 'Georgia, serif', color: '#999', fontSize: '9px', margin: 0 }}>www.restaurant-le-mas.fr</p>
        <p style={{ textAlign: 'center', fontFamily: 'Georgia, serif', color: '#999', fontSize: '9px', margin: '2px 0 0' }}>04 68 38 06 98</p>
      </div>
    </div>
  );
}

export default function CartePrint() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [settings, setSettings] = useState({});
  const [printZoom, setPrintZoom] = useState(100);
  const [showQrPrint, setShowQrPrint] = useState(true);
  const [showEmailModal, setShowEmailModal] = useState(false);

  // Get which tab to print from URL params
  const params = new URLSearchParams(window.location.search);
  const tab = params.get('tab') || 'carte';
  const showRoueQR = params.get('roue') !== 'false';

  useEffect(() => {
    const loadData = async () => {
      try {
        const [carteRes, settingsRes] = await Promise.all([
          fetch(`${API}/api/carte-items`),
          fetch(`${API}/api/site/settings`),
        ]);
        const carteData = await carteRes.json();
        let settingsData = {};
        try { settingsData = await settingsRes.json(); } catch {}
        setItems(carteData);
        setSettings(settingsData);
        setLoading(false);
        setTimeout(() => window.print(), 800);
      } catch {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  const pages = PREVIEW_PAGES[tab] || PREVIEW_PAGES.carte;
  const roueUrl = settings.roue_url || `${window.location.origin}/roue`;

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontFamily: 'Georgia, serif', color: '#1B2A52' }}>
        <p>Chargement du menu...</p>
      </div>
    );
  }

  return (
    <>
      <style>{`
        @media print {
          body { margin: 0; padding: 0; background: white; -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .no-print { display: none !important; }
          .print-menu-page { box-shadow: none !important; page-break-after: always; max-width: 100% !important; padding: 15mm 15mm 20mm !important; }
          .print-scale-wrapper { transform: none !important; padding-top: 0 !important; }
          .print-menu-page { font-size: ${printZoom}% !important; }
          @page { margin: 0; size: A4 portrait; }
        }
        @media screen {
          body { background: #e5e5e5; }
          .print-menu-page { box-shadow: 0 2px 8px rgba(0,0,0,0.1); margin-bottom: 24px !important; }
        }
      `}</style>

      {/* Print toolbar - hidden on print */}
      <div className="no-print" style={{ position: 'fixed', top: 0, left: 0, right: 0, background: '#1B2A52', color: 'white', padding: '10px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', zIndex: 100, flexWrap: 'wrap', gap: '8px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button onClick={() => window.history.back()} style={{ background: 'none', border: '1px solid rgba(255,255,255,0.3)', color: 'white', padding: '6px 16px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}>
            &larr; Retour
          </button>
          <span style={{ fontSize: '13px', fontWeight: 'bold' }}>Apercu impression — {tab.charAt(0).toUpperCase() + tab.slice(1)}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {/* Zoom */}
          <span style={{ fontSize: '10px', opacity: 0.6 }}>Zoom</span>
          <input type="range" min="60" max="150" value={printZoom} onChange={e => setPrintZoom(Number(e.target.value))}
            style={{ width: '80px', accentColor: '#0d9488' }} />
          <span style={{ fontSize: '10px', opacity: 0.6, width: '28px' }}>{printZoom}%</span>
          <div style={{ width: '1px', height: '20px', background: 'rgba(255,255,255,0.2)' }} />
          {/* QR toggle */}
          <label style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer', fontSize: '10px', opacity: showQrPrint ? 1 : 0.5 }}>
            <input type="checkbox" checked={showQrPrint} onChange={e => setShowQrPrint(e.target.checked)} style={{ accentColor: '#0d9488' }} />
            QR Code
          </label>
          <div style={{ width: '1px', height: '20px', background: 'rgba(255,255,255,0.2)' }} />
          {['carte', 'vins', 'boissons', 'desserts'].map(t => (
            <button key={t} onClick={() => { window.location.search = `?tab=${t}`; }}
              style={{ background: tab === t ? '#0d9488' : 'transparent', border: '1px solid rgba(255,255,255,0.3)', color: 'white', padding: '4px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '11px', textTransform: 'capitalize' }}>
              {t}
            </button>
          ))}
          <button onClick={() => setShowEmailModal(true)} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.3)', color: 'white', padding: '6px 12px', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}>
            Email
          </button>
          <button onClick={() => window.print()} style={{ background: '#0d9488', border: 'none', color: 'white', padding: '6px 20px', borderRadius: '4px', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold' }}>
            Imprimer
          </button>
        </div>
      </div>

      <div className="print-scale-wrapper" style={{ paddingTop: '60px', transform: `scale(${printZoom / 100})`, transformOrigin: 'top center' }}>
        {pages.map((pageConfig, idx) => (
          <PrintPage
            key={idx}
            pageConfig={pageConfig}
            items={items}
            pageNum={idx + 1}
            totalPages={pages.length}
            showRoueQR={showRoueQR && showQrPrint}
            isLastPage={idx === pages.length - 1}
            roueUrl={roueUrl}
          />
        ))}
      </div>

      {/* Email modal */}
      {showEmailModal && (
        <div className="no-print" style={{ position: 'fixed', inset: 0, zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'rgba(0,0,0,0.5)' }} onClick={() => setShowEmailModal(false)}>
          <div style={{ background: 'white', borderRadius: '12px', padding: '24px', maxWidth: '420px', width: '100%' }} onClick={e => e.stopPropagation()}>
            <h3 style={{ fontSize: '14px', fontWeight: 600, color: '#1B2A52', marginBottom: '16px' }}>Envoyer la carte par email</h3>
            <input id="carte-email-to" type="email" placeholder="email@exemple.com" style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '13px', marginBottom: '12px', boxSizing: 'border-box' }} data-testid="carte-print-email-to" />
            <textarea id="carte-email-msg" rows={3} defaultValue="Bonjour,&#10;&#10;Veuillez trouver ci-joint notre carte.&#10;&#10;Cordialement,"
              style={{ width: '100%', padding: '8px 12px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '12px', marginBottom: '12px', resize: 'none', boxSizing: 'border-box' }} data-testid="carte-print-email-msg" />
            <label style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px', cursor: 'pointer' }}>
              <input type="checkbox" id="carte-attach-pdf" defaultChecked={true} style={{ accentColor: '#1B2A52' }} data-testid="carte-attach-pdf-checkbox" />
              <span style={{ fontSize: '12px', color: '#1B2A52', fontWeight: 500 }}>Joindre la carte en PDF</span>
            </label>
            <p style={{ fontSize: '10px', color: '#0d9488', marginBottom: '12px', padding: '8px', background: '#f0fdf4', borderRadius: '6px' }}>Votre signature sera ajoutee automatiquement.</p>
            <div style={{ display: 'flex', gap: '8px' }}>
              <button onClick={() => setShowEmailModal(false)} style={{ flex: 1, padding: '8px', border: '1px solid #ddd', borderRadius: '6px', background: 'white', cursor: 'pointer', fontSize: '12px' }}>Annuler</button>
              <button data-testid="carte-print-send-email-btn" onClick={async () => {
                const to = document.getElementById('carte-email-to').value;
                const msg = document.getElementById('carte-email-msg').value;
                const attachPdf = document.getElementById('carte-attach-pdf').checked;
                if (!to) return;
                try {
                  const endpoint = attachPdf ? '/crm/send-carte-menu' : '/menu-du-jour/send-email';
                  const body = attachPdf
                    ? { to, subject: 'Carte du Restaurant - Le Mas', body: msg, carte: true, menu: false, sender: 'restaurant' }
                    : { to, subject: 'Carte du Restaurant - Le Mas', message: msg, menu_html: '<p>Voir notre carte : <a href="' + window.location.origin + '/site/restaurant/menu">Cliquez ici</a></p>' };
                  const res = await fetch(`${API}/api${endpoint}`, {
                    method: 'POST', headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(body)
                  });
                  const data = await res.json();
                  if (data.success || data.message) { alert('Email envoye !'); setShowEmailModal(false); }
                  else alert(data.error || data.detail || 'Erreur');
                } catch { alert('Erreur envoi'); }
              }} style={{ flex: 1, padding: '8px', border: 'none', borderRadius: '6px', background: '#1B2A52', color: 'white', cursor: 'pointer', fontSize: '12px', fontWeight: 600 }}>Envoyer</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
